import React, { type ReactElement } from 'react';

import { type CalendarPanelItemType } from '../Calendar';

import styles from '../Calendar.module.scss';

type CalendarSidePanelItemProps = {
    item: CalendarPanelItemType;
    onActive: (item: CalendarPanelItemType) => void;
    onDeactivate: () => void;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const CalendarSidePanelItem = ({
    item,
    onActive,
    onDeactivate,
    onClick
}: CalendarSidePanelItemProps): ReactElement => {
    const { title } = item;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);
    };
    const handleActive = () => onActive(item);
    const handleDeactivation = () => onDeactivate();

    return (
        <button
            type="button"
            className={styles.sidePanelItem}
            onClick={handleClick}
            onMouseOver={handleActive}
            onMouseOut={handleDeactivation}
            onFocus={handleActive}
            onBlur={handleDeactivation}
        >
            {title}
        </button>
    );
};
